import type { IntentContact } from '@/types/prequalify';
import type { UtmParams } from '@/hooks/useUtmParams';

/** Keep Sanity's dealer/configuration while applying the shopper's attribution. */
export function buildRouteOneFinancingUrl(
  configuredUrl: string | null | undefined,
  dealerId: string | undefined,
  utmParams: UtmParams = {},
  contact?: IntentContact
): string {
  let url = new URL('https://www.routeone.net/digital-retail-ui/');
  if (dealerId) url.searchParams.set('dealerId', dealerId);

  try {
    const configured = new URL(configuredUrl?.trim() || '');
    if (
      configured.protocol === 'https:' &&
      !configured.username &&
      !configured.password &&
      (configured.hostname === 'routeone.net' || configured.hostname.endsWith('.routeone.net'))
    ) {
      url = configured;
    }
  } catch {
    // Missing/invalid CMS links use the existing configured-dealer fallback.
  }

  for (const key of [
    'utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term',
    'gclid', 'gbraid', 'wbraid', 'msclkid', 'fbclid', 'ttclid', 'li_fat_id'
  ]) {
    const value = utmParams[key];
    if (value !== undefined && value !== null && String(value).trim()) {
      url.searchParams.set(key, String(value).trim());
    }
  }

  // Never retain somebody else's prefill from a CMS link or attribution cookie.
  const nameParts = contact?.name?.trim().split(/\s+/) ?? [];
  const prefill = {
    lead_capture_first_name: contact?.firstName ?? nameParts[0],
    lead_capture_last_name: contact?.lastName ?? nameParts.slice(1).join(' '),
    lead_capture_email: contact?.email,
    lead_capture_phone: contact?.phone,
  };
  for (const [key, value] of Object.entries(prefill)) {
    url.searchParams.delete(key);
    if (value?.trim()) url.searchParams.set(key, value.trim());
  }

  return url.toString();
}
